/**
Author - Sahil Dhingra
Git - https://github.com/sahildhingra-221
**/

const replaceWith = (data, replaceData, replaceWith) => {
  let newData = "";
  try {
    newData = data.replaceAll(replaceData, replaceWith);
  } catch {
    newData = data;
  }
  return newData;
};

export default replaceWith;
